module.exports = __webpack_public_path__ + "static/scale-model-of-historic-old-town-in-albuquerque-new-mexico-3ec2911fb4184f969fa3fbb9df121693.png";